module.exports = __webpack_public_path__ + "assets/images/profiles/1970-2-desktop.jpg?v=0c89d32d";